module.exports = __webpack_public_path__ + "static/media/hotels.f9ca467c.webp";